<script setup>

import { ref, watch } from 'vue';

const { message } = defineProps({
    message: String
});

const messageDiffere = ref(null);

watch(() => message, (msg) => {
    if (msg) {
        setTimeout(() => {
            if (message) {
                messageDiffere.value = msg;
            }
        }, 300);
    } else {
        messageDiffere.value = null;
    }
});

</script>

<template>
    <div class="message-chargement"
    v-if="messageDiffere">
        <div class="barre-progression">
            <div class="lumiere" />
        </div>
        {{ messageDiffere }}
    </div>
</template>

<style scoped>

.message-chargement {
    position: fixed;
    right: 10px;
    bottom: 10px;
    padding: 10px;
    border: 1px solid var(--couleur-bordure);
    border-radius: 6px;
    min-width: 200px;
    font-size: 12px;
}

.barre-progression {
    height: 10px;
    width: 100%;
    background-color: whitesmoke;
}

.lumiere {
    background-color: red;
    background-image: linear-gradient(
            to right,
            whitesmoke,
            var(--couleur-primaire),
            whitesmoke);
    height: 100%;
    width: 20%;
    animation: 0.4s linear 0s infinite alternate deplacer-lumiere;
}

@keyframes deplacer-lumiere {
    from {
        margin-left: 0%;
    } to {
        margin-left: 80%;
    }
}

</style>